"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Categories = void 0;
var Categories;
(function (Categories) {
    Categories["FLASHDASH"] = "flashdash";
    Categories["NEONIX"] = "neonix";
    Categories["TOP"] = "top";
    Categories["GAMBEX"] = "gambex";
    Categories["NEW"] = "new";
    Categories["RECOMMENDED"] = "recommended";
    Categories["MAGIC"] = "magic";
    Categories["NOVOMATIC"] = "novomatic";
    Categories["XMAS"] = "xmas";
    Categories["MEGA_WAYS"] = "mega_ways";
    Categories["GEMS"] = "gems";
    Categories["ROMANTIC"] = "romantic";
    Categories["PRAGMATIC"] = "pragmatic";
    Categories["LIVE"] = "live";
    Categories["NOT_LIVE"] = "not_live";
    Categories["JACKPOTS"] = "jackpots";
    Categories["INSTANT"] = "instant";
    Categories["INSTANT_GAME"] = "instantgame";
    Categories["BONUS"] = "bonus";
    Categories["ALL_GAMES"] = "all_games";
    Categories["FRUITS"] = "fruits";
    Categories["ANIMALS"] = "animals";
    Categories["SPORT"] = "sport";
    Categories["SUMMER"] = "summer";
    Categories["BOOK_OF_SLOTS"] = "booksofslots";
    Categories["FISHING"] = "fishing";
    Categories["SPORTS"] = "sports";
    Categories["EGYPT"] = "egypt";
    Categories["BOOKS"] = "books";
    Categories["WILDWEST"] = "wildwest";
    Categories["POKER"] = "poker";
    Categories["ROULETTE"] = "roulette";
    Categories["BLACKJACK"] = "blackjack";
    Categories["BACCARAT"] = "baccarat";
    Categories["OCTOBERFEST"] = "oktoberfest";
    Categories["HALLOWEEN"] = "halloween";
    Categories["HOLDANDWIN"] = "holdandwin";
    Categories["HOLD_WIN"] = "hold_win";
    Categories["BONUSBUY"] = "bonusbuy";
    Categories["VELENTINES_DAY"] = "valentinesday";
    Categories["TRENDING"] = "trending";
    Categories["RECOMMENDATION_NEW"] = "recommendation-new";
    Categories["TABLE"] = "table";
    Categories["FANTASY"] = "fantasy";
    Categories["CRASH_GAMES"] = "crashgames";
    Categories["CRASH"] = "crash";
    Categories["MEGAWAYS"] = "megaways";
    Categories["DROPS_WINS"] = "drops_wins";
    Categories["POPULAR"] = "popular";
    Categories["HOT"] = "hot";
    Categories["CLASSIC"] = "classic";
    Categories["COINS"] = "coins";
    Categories["ALL"] = "all";
    Categories["HIGH"] = "high";
})(Categories = exports.Categories || (exports.Categories = {}));
